module.exports = __webpack_public_path__ + "img/AFMS_BB_LWN.ce6cb053.png";